/*! JointJS+ v3.6.1 - HTML5 Diagramming Framework

Copyright (c) 2022 client IO

 2022-10-21 


This Source Code Form is subject to the terms of the JointJS+ License
, v. 2.0. If a copy of the JointJS+ License was not distributed with this
file, You can obtain one at http://jointjs.com/license/rappid_v2.txt
 or from the JointJS+ archive as was distributed by client IO. See the LICENSE file.*/


import * as joint from '@clientio/rappid';

export class KeyboardService {
    
    constructor() {
        this.keyboard = new joint.ui.Keyboard();
    }
    
    create(graph, clipboard, selection, paperScroller, commandManager) {
        
        this.keyboard.on({
            'ctrl+plus': (evt) => {
                evt.preventDefault();
                paperScroller.zoom(0.2, { max: 5, grid: 0.2 });
            },
            
            'ctrl+minus': (evt) => {
                evt.preventDefault();
                paperScroller.zoom(-0.2, { min: 0.2, grid: 0.2 });
            },
        });
    }
}
